import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppUrl } from './constants/app-url';
import { PrivateLayoutComponent } from './layout/private-layout/private-layout.component';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';

const routes: Routes = [
  //Site routes goes here 
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: '', redirectTo: AppUrl.DASHBOARD, pathMatch: 'full' },
      { path: AppUrl.DASHBOARD, loadChildren: () => import('../app/component/dashboard/dashboard.module').then(m => m.DashboardModule) },
    ]
  }, {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: AppUrl.DASHBOARD, loadChildren: () => import('../app/component/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: AppUrl.HEARTBEAT, loadChildren: () => import('../app/component/heartbeat/heartbeat.module').then(m => m.HeartbeatModule) },
      { path: AppUrl.ERROR_ALARM, loadChildren: () => import('../app/component/error-alarm/erro-alarm.module').then(m => m.ErrorAlarmModule) },
      { path: AppUrl.TRANSACTION, loadChildren: () => import('../app/component/transaction/transaction.module').then(m => m.TransactionModule) },
      { path: AppUrl.SYSTEM_SPECIFICATION, loadChildren: () => import('../app/component/system-specification/system-specification.module').then(m => m.SystemSpecificationModule) },
      { path: AppUrl.MACHINE, loadChildren: () => import('../app/component/machine/machineModule').then(m => m.MachineModule) }
    ]
  },
  // App routes goes here here

  { path: '**', redirectTo: AppUrl.DASHBOARD }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    scrollOffset: [0, 100],
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
